import { useOffset, useXAxisScale } from 'recharts';
import { Warning600 } from '@src/utils/colors';
import { WeekRow } from '../data-qa-types';
import { formatCurrency } from '../data-qa-utils';

interface MarginalCaretsLayerProps {
  weeks: WeekRow[];
}

// Same Recharts 3.x hook migration as DivergenceMarkersLayer -- see its own comment.
export const MarginalCaretsLayer = ({ weeks }: MarginalCaretsLayerProps) => {
  const scale = useXAxisScale();
  const offset = useOffset();
  if (!scale) return undefined;

  const drifted = weeks.filter(w => w.hasDrift);

  return (
    <g className='data-qa-marginal-carets'>
      {drifted.map(week => {
        const x = scale(week.weekLabel, { position: 'middle' });
        if (typeof x !== 'number' || Number.isNaN(x)) return undefined;
        const y = (offset?.top ?? 0) - 2;
        return (
          <g key={week.weekIso} transform={`translate(${x}, ${y})`}>
            <title>
              {week.weekIso}: prior {formatCurrency(week.priorSpend ?? 0)} → current{' '}
              {formatCurrency(week.spend)}
            </title>
            <polygon points='-5,0 5,0 0,-7' fill={Warning600} />
          </g>
        );
      })}
    </g>
  );
};
